import React from "react";

import MediaCardSection from "./Reusables/MediaCardSection";
export default function JournalEditionsList(props) {
	let journalEditions = props?.journalEditions?.items || [];
	journalEditions = journalEditions
		.sort((a, b) => new Date(b.fields.editionDate).getTime() - new Date(a.fields.editionDate).getTime())
		.map((j) => {
			//data fetched via graphQL does not contain a content type
			j.sys.contentType = { sys: { id: "journalEditions" } };
			return j;
		});

	return <MediaCardSection data={{ fields: { columnCount: 3, isContainer: "md", mediaCards: journalEditions } }} />;
}
